const Themes = {
  Dark: 'dark',
  Light: 'light',
  CarouselDark: 'carousel-dark',
  CarouselLight: 'carousel-light'
};

export default Themes;
